import { render, staticRenderFns } from "./ProposedCommentsDue.vue?vue&type=template&id=7427fb38"
import script from "./ProposedCommentsDue.vue?vue&type=script&lang=js"
export * from "./ProposedCommentsDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports